import { render, staticRenderFns } from "./TipTap2.vue?vue&type=template&id=61266e5c&"
import script from "./TipTap2.vue?vue&type=script&lang=js&"
export * from "./TipTap2.vue?vue&type=script&lang=js&"
import style0 from "./TipTap2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports